import * as React from "react";

import { CommonControlProps } from "@common/components/Atoms/FormInputs/commonControlProps";
import { IconCheck, IconFrown } from "@common/components/Atoms/Icons";

interface InputProps extends CommonControlProps {
    isValid: boolean;
    onChange?: (name: string, value: any) => void;
    onEnterKey?: (e: any) => void;
    validationMessages: string[];
    value?: string | number;
    inputClassName?: string;
    autoComplete?: string;
    placeholder?: string;
    name: string;
    label?: string;
    description?: string;
    type: string;
    required?: boolean;
    readOnly?: boolean;
    maxLength?: number;
    inputRef?: any;
    dataCy?: string;
}

interface InputState {
    placeholder: string;
    untouched: boolean;
}
export class Input extends React.Component<InputProps, InputState> {
    static defaultProps = {
        autoComplete: "On",
        inputClassName: "",
        isValid: true,
        name: "",
        readOnly: false,
        required: false,
        type: "text",
        maxLength: 255,
        validationMessages: [],
    };

    constructor(props: InputProps) {
        super(props);
        this.state = {
            untouched: true,
            placeholder: this.props.placeholder || "",
        };
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
    }

    onKeyPress(e) {
        if (e.key === "Enter" && !!this.props.onEnterKey) {
            e.preventDefault();
            e.persist();
            this.props.onEnterKey(e);
        }
    }

    onChange(event) {
        this.setState({ untouched: false });
        if (this.props.onChange) {
            this.props.onChange(this.props.name, event.target.value);
        }
    }

    onBlur() {
        this.setState({ placeholder: this.props.placeholder || "" });
        if (this.props.onBlur) this.props.onBlur(this.props.name);
    }

    onFocus() {
        this.setState({ placeholder: "" });
        if (this.props.onFocus) this.props.onFocus(this.props.name);
    }

    render() {
        return (
            <div className="c-block">
                <div
                    className={
                        "c-control c-control--text " +
                        (!this.props.isValid ? "has-error" : "")
                    }
                >
                    {this.props.label && (
                        <div className="c-control__label">
                            <label htmlFor={"input_" + this.props.name}>
                                {this.props.label}
                            </label>
                            {this.props.description && (
                                <p>{this.props.description}</p>
                            )}
                        </div>
                    )}
                    <div className="c-control__wrapper">
                        <input
                            className={`c-control__input ${
                                this.props.inputClassName
                            } ${!this.props.isValid ? "has-error" : ""}`}
                            type={this.props.type}
                            id={"input_" + this.props.name}
                            name={this.props.name}
                            value={
                                !!this.props.value
                                    ? this.props.value.toString()
                                    : ""
                            }
                            data-cy={this.props.dataCy}
                            required={this.props.required}
                            readOnly={this.props.readOnly}
                            autoComplete={this.props.autoComplete}
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            placeholder={this.state.placeholder}
                            maxLength={this.props.maxLength}
                            onKeyPress={this.onKeyPress}
                            ref={this.props.inputRef}
                        />

                        {/*!!this.props.current_value && this.props.is_focused &&
                    <button className="c-control__action" type="button" tabIndex="-1" onClick={this.handleClearClick}><IconClose /></button>
                    */}

                        {this.props.isValid && !this.state.untouched && (
                            <div
                                className="c-control__valid"
                                id={"input-valid_" + this.props.name}
                            >
                                <IconCheck />
                            </div>
                        )}
                    </div>
                    {!this.props.isValid && (
                        <div className="c-control__message">
                            <IconFrown />
                            {this.props.validationMessages.map((msg, ind) => (
                                <span
                                    key={ind}
                                    id={"input-error_" + this.props.name}
                                >
                                    {msg + " "}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
